import { getWardLabel, IWardLabel } from "../utils/wardLabel";

/**
 * React hook exposing the current hospital's "Ward" label in its four casings.
 * Thin wrapper over {@link getWardLabel} — the label is fixed for the session
 * (sourced from the cached hospital configuration), so no state/subscription is
 * needed. For non-component code (column factories, schemas) call getWardLabel directly.
 */
export function useWardLabel(): IWardLabel {
  return getWardLabel();
}
